import React from 'react';

import {ApplicationsControl} from '../components/ApplicationsControl';
import {SigninOptionsControl} from '../components/SigninOptionsControl';
import {VersionControl} from '../components/VersionControl';
import {UserAccountsControl} from '../components/UserAccountsControl';

import {I18n} from '@aws-amplify/core';

import {Box, Grid, Stack, Title} from '@mantine/core';

import config from 'config';

const { about } = config;

export const IndexPage = () => {
    return (
        <Stack spacing="xl">
            <Title order={4} data-testid="page-title">
                {I18n.get('About') + ':'}
            </Title>

            <Grid>
                <Grid.Col span={6}>
                    <Box variant="h4">{I18n.get('Application Name')}:</Box>
                </Grid.Col>
                <Grid.Col span={6}>
                    <Box variant="h5">{about.name}</Box>
                </Grid.Col>
            </Grid>

            <VersionControl />
            <UserAccountsControl />
            <ApplicationsControl />
            <SigninOptionsControl />
        </Stack>
    );
};
